var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#2B2B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32847 6.57953C8.00249 6.90551 8.00249 7.43209 8.32847 7.75808L11.5716 11.0012L8.32847 14.2443C8.00249 14.5703 8.00249 15.0968 8.32847 15.4228C8.65445 15.7488 9.18104 15.7488 9.50702 15.4228L13.3436 11.5863C13.6696 11.2603 13.6696 10.7337 13.3436 10.4077L9.50702 6.57117C9.1894 6.25354 8.65445 6.25354 8.32847 6.57953Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonOpen);
export default __webpack_public_path__ + "static/media/buttonOpen.fe7e63da55365d6c53cf46c046eef22d.svg";
export { ForwardRef as ReactComponent };